(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueStatusDialogController', QueueStatusDialogController);

    QueueStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'QueueStatus'];

    function QueueStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, QueueStatus) {
        var vm = this;

        vm.queueStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queueStatus.id !== null) {
                QueueStatus.update(vm.queueStatus, onSaveSuccess, onSaveError);
            } else {
                QueueStatus.save(vm.queueStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
